import {OtsUIState} from "../../ots-ui-store";

export const getDriverActivityPageCriteria = (state: OtsUIState) => state.uiDriverActivityPage.criteria
export const getDriverActivityPageFilter = (state: OtsUIState) => state.uiDriverActivityPage.filter
export const getDriverActivityPageState = (state: OtsUIState) => state.uiDriverActivityPage.state
export const getDriverActivityPageHiddenPersons = (state: OtsUIState) => state.uiDriverActivityPage.hiddenPersonIds
